import { Command } from '@nest/internal-frontend';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useNumberParam } from '../../../helpers';

export const useCommandGoToNewConsignmentNote = (): Command => {
	const navigate = useNavigate();
	const carrierId = useNumberParam('carrierId');

	return {
		id: 'go-to-new-consignment-note',
		label: 'Nová nakládka',
		icon: <Plus className="h-4 w-4" />,
		shortcut: undefined,
		disabled: undefined,
		loading: undefined,
		run: async () => {
			navigate(`/consignment-notes/carriers/${carrierId}/new`);
		}
	};
};
